import { startTransition, useEffect } from 'react';

import { queryErrorEntry, useDelayedContinuousQueryError } from '@/hooks/useDelayedContinuousQueryError';
import useGetDefectenWithLocation from '@/queries/defecten/useGetDefectenWithLocation';

import useGetLmmVoorraad from './hooks/useGetLmmVoorraad';
import useLmmStore from './state/useLmmStore';

/** Computes the 3 tijdstippen, rounding 'Nu' to the minute so the query key stays stable within it. */

export default function useLmmView() {
  const setLmmResponse = useLmmStore((state) => state.setLmmResponse);
  const setDefecten = useLmmStore((state) => state.setDefecten);

  const lmmVoorraadQuery = useGetLmmVoorraad();
  const defectenWithLocationQuery = useGetDefectenWithLocation({ days: 2 }, 10_000); // If number of days changes, change the equivelent of hours in domain/defect/defect.ts
  const { isBlockingError } = useDelayedContinuousQueryError({
    scope: 'lmm',
    criticalQueries: [
      queryErrorEntry('lmm-voorraad-v2', lmmVoorraadQuery),
      queryErrorEntry('defecten-met-locatie', defectenWithLocationQuery),
    ],
  });

  useEffect(() => {
    if (!defectenWithLocationQuery.isSuccess || defectenWithLocationQuery.data === undefined) {
      return;
    }
    startTransition(() => {
      const { defecten, locatieVoorEenheden } = defectenWithLocationQuery.data;
      setDefecten(defecten, locatieVoorEenheden);
    });
  }, [defectenWithLocationQuery.data, defectenWithLocationQuery.isSuccess, setDefecten]);

  useEffect(() => {
    startTransition(() => {
      if (lmmVoorraadQuery.isSuccess && lmmVoorraadQuery.data && Array.isArray(lmmVoorraadQuery.data)) {
        setLmmResponse(lmmVoorraadQuery.data);
      }
    });
  }, [lmmVoorraadQuery.data, lmmVoorraadQuery.isSuccess, setLmmResponse]);

  return {
    isBlockingError,
    refetchCritical: () => {
      void lmmVoorraadQuery.refetch();
      void defectenWithLocationQuery.refetch();
    },
  };
}
